// Constants
export const LINE_HEIGHT = 20; // 14px * 1.43 line-height ≈ 20px
export const MAX_LINES_DESKTOP = 5;
export const MAX_LINES_MOBILE = 9;
export const MAX_HEIGHT_DESKTOP = LINE_HEIGHT * MAX_LINES_DESKTOP;
export const MAX_HEIGHT_MOBILE = LINE_HEIGHT * MAX_LINES_MOBILE;
export const ANIMATION_DURATION = 1000;

export const getProgressColor = (percentage, text, isDark) => {
  if (percentage <= 20) {
    return text ? (isDark ? "#f9e3e2" : "#752522") : "#F93765";
  } else if (percentage < 40) {
    return text ? (isDark ? "#f6cccb" : "#752522") : "#E87B35";
  } else if (percentage < 60) {
    return text ? (isDark ? "#f3bd7f" : "#73321B") : "#ed974f";
  } else if (percentage < 80) {
    return text ? (isDark ? "#f8d8b0" : "#b34a22") : "#f3bd7f";
  } else {
    return text ? (isDark ? "#d5faf1" : "#254D4A") : "#68D1BF";
  }
};

export const getMaxHeight = (isMobile) =>
  isMobile ? MAX_HEIGHT_MOBILE : MAX_HEIGHT_DESKTOP;
